<template>
    <div class="wrap">
        <Heading :isLogin="isLogin"></Heading>
        <div class="content">
            <div id="hotlist" class="hotlist-wrap">
                <h1 class="page-title">新能源汽车推荐车型目录</h1>
                <div class="filter-wrapper container">
                    <div class="grid-4">
                        <p class="filter-title">企业名(可多选)</p>
                        <!-- <select class="" name="" v-model="filter.enterprise_name">
                            <option value="ff">ff</option>
                            <option value="fe">fe</option>
                            <option value="fv">fv</option>
                        </select> -->
                        <multiselect :options="entOptions" v-on:selected="entSelected"></multiselect>
                    </div>
                    <div class="grid-4">
                        <p class="filter-title">品牌</p>
                        <select class="" name="" v-model="filter.brand" :disabled="brandDisabled">
                            <option v-for="brand in brands" :value="brand">{{brand}}</option>
                        </select>
                    </div>
                    <div class="grid-4">
                        <p class="filter-title">新能源车类型（可多选）</p>
                        <multiselect :options="carTypeOptions" v-on:selected="carTypeSelected"></multiselect>
                    </div>

                    <div class="grid-4">
                        <p class="filter-title">电池系统供应商</p>
                        <select class="" name="" v-model="filter.battery_system">
                            <option v-for="battery in batterys" :value="battery">{{battery}}</option>
                        </select>
                    </div>
                    <div class="grid-4">
                        <p class="filter-title">电驱动系统供应商</p>
                        <select class="" name="" v-model="filter.electric_drive">
                            <option v-for="drive in drives" :value="drive">{{drive}}</option>
                        </select>
                    </div>
                    <div class="grid-4">
                        <p class="filter-title">超级电容供应商</p>
                        <select class="" name="" v-model="filter.ultracapacitor">
                            <option v-for="ultracapacitor in ultracapacitors" :value="ultracapacitor">{{ultracapacitor}}</option>
                        </select>
                    </div>

                    <div class="grid-4">
                        <p class="filter-title">发动机供应商</p>
                        <select class="" name="" v-model="filter.engine">
                            <option v-for="engine in engines" :value="engine">{{engine}}</option>
                        </select>
                    </div>
                    <div class="grid-4">
                        <p class="filter-title">是否免税</p>
                        <select class="" name="" v-model="filter.is_free_tax">
                            <option value="1">是</option>
                            <option value="0">否</option>
                        </select>
                    </div>
                    <div class="grid-4">
                        <p class="filter-title">是否补贴</p>
                        <select class="" name="" v-model="filter.is_subsidy">
                            <option value="1">是</option>
                            <option value="0">否</option>
                        </select>
                    </div>
                    <div class="btn-wrapper">
                        <button class="btn btn-white" type="button" name="button" @click="resetFilter()">还原默认</button>
                        <button class="btn btn-blue" type="button" name="button" @click="submit()">筛选</button>
                    </div>
                </div>

                <div class="filter-result" v-show="searched">
                    <div class="filter-result-title container">
                        <h3>筛选后 共 {{list.total}} 条结果</h3>
                        <a href="javascript:;" @click="download()">下载筛选结果</a>
                    </div>
                    <div class="filter-result-item" v-for="(item, index) in list.data">
                        <!--<p class="result-title">纯电动扫路车</p>-->
                        <div class="result-block container">
                            <div class="grid-4">
                                <p class="notification-number">
                                    {{item.notice_num}}
                                    <span class="free-icon" v-show="item.is_free_tax === '1'">免</span>
                                    <span class="subsidy-icon" v-show="item.is_subsidy === '1'">补</span>
                                </p>
                                <p class="company-name">{{item.enterprise_name}}</p>
                            </div>
                            <div class="grid-4">
                                <p class="brand-name">
                                    {{item.brand}}
                                    <span class="car-type">{{item.car_type}}</span>
                                </p>
                                <p class="dir-order">{{item.duty_batch}}</p>
                            </div>
                            <div class="grid-4">
                                <a class="dropdown-anchor" href="javascript:;" :id="'list-' + index"  @click="showDetail($event)">详情</a>
                            </div>

                        </div>

                        <div class="result-block result-dropdown-content container" :id="'block-' + index">
                            <div class="container">
                                <div class="grid-4">
                                    <p class="notification-number">
                                        {{item.notice_num}}
                                        <span class="free-icon" v-show="item.is_free_tax === '1'">免</span>
                                        <span class="subsidy-icon" v-show="item.is_subsidy === '1'">补</span>
                                    </p>
                                    <p class="company-name">{{item.enterprise_name}}</p>
                                </div>
                                <div class="grid-4">
                                    <p class="brand-name">
                                        {{item.brand}}
                                        <span class="car-type">{{item.car_type}}</span>
                                    </p>
                                    <p class="dir-order">{{item.duty_batch}}</p>
                                </div>
                                <div class="grid-4">
                                    <!--<a class="dropdown-anchor" href="javascript:;">详情</a>-->
                                </div>
                            </div>

                            <div class="supplier-detail container">
                                <div class="make-distance container">
                                    <div class="grid-4">
                                        <p class="grey-text">配置ID</p>
                                        <p>
                                            {{item.configure_id}}
                                        </p>
                                    </div>
                                    <div class="grid-4">
                                        <p class="grey-text">电池系统供应商</p>
                                        <p>{{item.battery_system}}</p>
                                    </div>
                                    <div class="grid-4">
                                        <p class="grey-text">电驱动系统供应商</p>
                                        <p>
                                            {{item.electric_drive}}
                                        </p>
                                    </div>
                                </div>

                                <div class="grid-4">
                                    <p class="grey-text">
                                        超级电容供应商
                                    </p>
                                    <p>
                                        {{item.ultracapacitor}}
                                    </p>
                                </div>
                                <div class="grid-4">
                                    <p class="grey-text">发动机供应商</p>
                                    <p>
                                        {{item.engine}}
                                    </p>
                                </div>
                            </div>
                            <div class="performance-detail container">
                                <div class="make-distance container">
                                    <div class="grid-4">
                                        <p class="grey-text">
                                            纯电续驶里程（km）
                                        </p>
                                        <p>
                                            {{item.ev_mileage}}
                                        </p>
                                    </div>
                                    <div class="grid-4">
                                        <p class="grey-text">
                                            发动机排量（mL）
                                        </p>
                                        <p>
                                            {{item.engine_output}}
                                        </p>
                                    </div>
                                    <div class="grid-4">
                                        <p class="grey-text">整车整备质量（kg）</p>
                                        <p>
                                            {{item.quality}}
                                        </p>
                                    </div>
                                </div>

                                <div class="grid-4">
                                    <p class="grey-text">
                                        动力蓄电池组总能量（kWh）
                                    </p>
                                    <p>
                                        {{item.battery_power}}
                                    </p>
                                </div>
                                <div class="grid-4">
                                    <p class="grey-text">
                                        燃料消耗量（L/100km）
                                    </p>
                                    <p>
                                        {{item.fuel_wastage}}
                                    </p>
                                </div>
                                <div class="grid-4">
                                    <p class="grey-text">
                                        动力蓄电池组总质量（kg）
                                    </p>
                                    <p>
                                        {{item.battery_quality}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <p class="list-footer">
                        <button class="btn btn-blue" type="button" name="button" @click="more()" v-show="list.to">更多</button>
                    </p>
                </div>
            </div>
        </div>
        <Side :ad="ad"></Side>
    </div>
</template>
<script>
import axios from 'axios'
import multiselect from './multiselect';
import Side from './Side'
import Heading from './Header'

export default {
    name: "hotlist",
    components: {
        Side,
        Heading,
        multiselect
    },
    data: function data() {
        return {
            isLogin: false,
            ad: {},
            filter: {
                enterprise_name: '',
                brand: '',
                car_type: '',
                battery_system: '',
                electric_drive: '',
                ultracapacitor: '',
                engine: '',
                is_free_tax: '',
                is_subsidy: ''
            },
            brands: [],
            batterys: [],
            drives: [],
            ultracapacitors: [],
            engines: [],
            entOptions: [],
            carTypeOptions: [],
            brandDisabled: true,
            page: 1,
            list: {
                to: '',
                data: []
            },
            searched: false
        }
    },
    created () {

    },
    methods: {
        resetFilter () {
            for (var oKey in this.filter) {
                if (this.filter.hasOwnProperty(oKey)) {
                    this.filter[oKey] = '';
                }
            }
            // this.brands = [];
            // this.batterys = [];
            // this.drives = [];
            // this.ultracapacitors = [];
            // this.engines = [];
            // this.entOptions = [];
            // this.carTypeOptions = [];
            this.brandDisabled = true;
            this.page = 1;
            this.searched = false;
            this.list = {
                to: '',
                data: []
            }
        },
        entSelected (e) {
            this.filter.enterprise_name = e;
            this.brandDisabled = e && e.split(',').length !== 1;
            if (!this.brandDisabled) {
                this.getBrand(e);
            }
        },
        carTypeSelected (e) {
            this.filter.car_type = e;
        },
        getBrand (d) {
            axios.get('/api/car/recommended/get_brand' + '?enterprise_name=' + d)
            .then((d) => {
                if (d.data.code === 0) {
                    this.brands = d.data.data;
                }
            })
            .catch((e) => {})
        },
        showDetail (e) {
            var tId = e.target.getAttribute('id');
            var bId = tId.split('-')[1];
            var s = document.getElementById('block-' + bId).style.display;
//            if (s === 'none') {
                e.target.classList.toggle('active')
//            }
            document.getElementById('block-' + bId).style.display = s === 'block' ? 'none' : 'block';
        },
        download () {
            var count = 0, s = '';
            for (var oKey in this.filter) {
                if (this.filter[oKey]) {
                    count ++;
                    s += oKey + '=' + this.filter[oKey] + '&';
                }
            }
            if (count === 0) {
                alert('请先选择筛选条件');
                return;
            }
//            axios.get('/api/car/recommended/download_car_excel?' + s)
//            .then((d) => {
//                console.log(d);
//                if (d.status === 200) {
//                    this.createDownload('推荐车型目录.xls', d.data);
//                }
//
//            })
//            .catch(() => {})
            this.createDownload('/api/car/recommended/download_car_excel?' + s);
        },
        createDownload (content) {
                var IFrameRequest = document.createElement("iframe");
                IFrameRequest.id = "IFrameRequest";
                IFrameRequest.src = content;
                IFrameRequest.style.display="none";
                document.body.appendChild(IFrameRequest);

        },
        submit () {
            var count = 0, s = '';
            for (var oKey in this.filter) {
                if (this.filter[oKey]) {
                    count ++;
                    s += oKey + '=' + this.filter[oKey] + '&';
                }
            }
            if (count === 0) {
                alert('请先选择筛选条件');
                return;
            }
            this.searched = true;
            axios.get('/api/car/recommended/car?' + s + 'offset=30&page=1')
            .then((d) => {
                if (d.data.code === 0) {
                    this.list.data = d.data.data.data;
                    this.list.to = d.data.data.to;
                    this.page ++;
                }
            })
            .catch(() => {})
        },
        more () {
            var count = 0, s = '';
            for (var oKey in this.filter) {
                if (this.filter[oKey]) {
                    count ++;
                    s += oKey + '=' + this.filter[oKey] + '&';
                }
            }
            if (count === 0) {
                alert('请先选择筛选条件');
                return;
            }

            axios.get('/api/car/recommended/car?' + s + 'offset=30&page=' + this.page)
            .then((d) => {
                if (d.data.code === 0) {
                    this.list.data = this.list.data.concat(d.data.data.data);
                    this.list.to = d.data.data.to;
                    this.page ++;
                }
            })
            .catch(() => {})
        }
    },
    created () {
        axios.get('/api/car/recommended/select_option')
        .then((d) => {
            if (d.data.code === 0) {
                this.entOptions = d.data.data.enterprise_name;
                this.carTypeOptions = d.data.data.car_type;
                this.batterys = d.data.data.battery_system;
                this.drives = d.data.data.electric_drive;
                this.ultracapacitors = d.data.data.ultracapacitor;
                this.engines = d.data.data.engine;
            }
        })
        .catch((e) => {
            console.log(e);
        })
    }
}
</script>
<style lang="scss" scoped>
.wrap {
    width: 1030px;
    margin: 0 auto;
    padding-top: 100px;
    &:after {
        content: "";
        display: block;
        clear: both;
    }
}
.content {
    float: left;
    width: 760px;
    background-color: #fff;
    box-sizing: border-box;
    .top-ad {
        width: 700px;
        height: 90px;
        padding: 20px 30px 0 30px;
        margin-bottom: 30px;
    }
}
.hotlist-wrap {
    padding: 30px;
    .page-title {
        font-size: 36px;
        margin: 0 0 30px 0;
    }
}
.filter-wrapper {
    padding: 30px;
    box-shadow: 0 1px 5px 0 rgba(0,0,0,0.10);
    border: 1px solid #e5e5e5;
    background: #fff;
    .grid-4 {
        box-sizing: border-box;

        margin: 0 0 20px 0;
        & + .grid-4 {
            padding-left: 20px;
        }
        &:nth-of-type(3n+1) {
            padding: 0;
        }

    }
    .btn-blue {
        padding-right: 48px;
        padding-left: 48px;
    }
    .btn-wrapper {
        text-align: center;
    }
    select {
        width: 100%;
        height: 32px;
        line-height: 32px;
    }
}
.filter-title {
    font-size: 12px;
    margin: 0 0 8px 0;
}
.btn {
    height: 40px;
    text-align: center;
    border-radius: 2px;
    color: #fff;
    border: none;
    outline: 0;
    cursor: pointer;
    transition: all ease 0.3s;
}
.btn-blue {
    background-color: #0666B2;
    padding-right: 30px;
    padding-left: 30px;
    &:hover {
        background-color: darken(#0666B2, 10%);
    }
}
.btn-white {
    background-color: #fff;
    color: #0666B2;
    border: 1px solid #0666B2;
    padding-right: 35px;
    padding-left: 35px;
}
.filter-result {
    padding-top: 30px;
    background: #fff;
    .list-footer {
        text-align: center;
        padding: 20px 0;
    }
    .filter-result-title {
        padding-bottom: 20px;
        h3 {
            font-size: 16px;
            font-weight: bold;
            float: left;
        }
        a {
            color: #0666B2;
            font-size: 14px;
            float: right;
        }
    }
    .result-dropdown-content {
        display: none;
        border: 2px solid #0666B2 !important;
        padding: 20px;

        .supplier-detail {
            margin-top: 20px;
            padding: 20px 0;
            border-top: 1px dashed #eee;
            border-bottom: 1px dashed #eee;
            .make-distance {
                margin-bottom: 50px;
            }
        }
        .grey-text {
            color: #999;
            font-size: 12px;
            margin-bottom: 8px;
        }
        .performance-detail {
            padding-top: 20px;
            .make-distance {
                margin-bottom: 30px;
            }
        }
    }
    .filter-result-item {
        .result-title {
            background: #F2F2F2;
            border-top: 1px solid #999;
            padding: 8px 20px;
        }
        .result-block {
            padding: 20px;
            &:not(:last-child) {
                border-bottom: 1px solid #eee;
            }
            .notification-number {
                color: #000;
                margin-bottom: 8px;
                font-weight: bold;
            }
            .free-icon {
                background: #62BBEE;
                width: 16px;
                height: 16px;
                padding-right: 2px;
                padding-left: 2px;
                border-radius: 2px;
                color:#fff;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                margin-left: 12px;
            }
            .subsidy-icon {
                background: #F97C99;
                width: 16px;
                height: 16px;
                padding-right: 2px;
                padding-left: 2px;
                border-radius: 2px;
                color:#fff;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                margin-left: 12px;
            }
            .company-name {
                font-size: 14px;
            }
            .brand-name {
                font-size: 14px;
                margin-bottom: 10px;
            }
            .dir-order {
                font-size: 14px;
                color: #999;
            }
            .dropdown-anchor {
                font-size: 14px;
                color: #0666B2;
                &:after {
                    content: '\25B2';
                    margin-left: 5px;
                }
                &.active:after {
                    content: '\25BC';
                }
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// Hotlist.vue?7341945f